import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";
import { BtnToolBarWrap, BtnTool } from "shared/BtnToolBar/styled";
import { MainTitle } from "styles/General.styled";
import { MetaWrap } from "shared/Meta/styled";
import { BannerWrap, BannerTitle } from "shared/Banner/styled";
import { CardWrap, Column, Card, CardImage } from "styles/MainCards.styled";
import { PreviewImg } from "styles/Preview.styled";
import { StarSVG, RatingContainer } from "shared/Rating/styled";

/* Style HeadBlock */
export const HeadBlock = styled.div`
  margin-top: 5px;
  margin-bottom: 17px;
  ${MainTitle} {
    font-family: ${fonts.abhayaBold};
    line-height: 1.325;
    margin-bottom: 0;
  }
  ${MetaWrap} {
    letter-spacing: 0.01em;
    > div {
      margin-left: 1px;
    }
    > div + div {
      margin-left: 3px;
    }
  }
  @media (min-width: 769px) {
    margin-top: 0;
    margin-bottom: 10px;
    padding-bottom: 4px;
    ${(props) =>
      !props.hideBorder
        ? `border-bottom: 1px solid ${colors.GREY_SEMILIGHT};`
        : `
      margin: 0;
      padding: 0;
    `}

    ${BtnToolBarWrap} {
      margin-left: 35px;
    }
    ${MainTitle} {
      margin-bottom: 0;
      line-height: 1;
    }
    ${MetaWrap} {
      margin: 0;
      > div {
        margin-left: 1px;
      }
    }
    &.height {
      min-height: 69px;
    }
  }
`;
/* Style ToolBarWrap */
export const ToolBarWrap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid ${colors.GREY_LIGHT};
  @media (min-width: 769px) {
    padding-bottom: 0;
    border-bottom: none;
    ${BtnTool} {
      padding: 0 12px 6px;
    }
    .icon {
      margin-bottom: 2px;
    }
  }
`;

export const CardWrapType1 = styled(CardWrap)`
  position: relative;
  padding-bottom: 81px;
  margin-left: -8px;
  margin-right: -8px;
  padding-top: 1px;
  &:before {
    content: "";
    position: absolute;
    display: block;
    height: 1px;
    left: 15px;
    right: 15px;
    background-color: ${colors.GREY_LIGHT};
  }
  @media (min-width: 769px) {
    margin-left: -15px;
    margin-right: -15px;
  }
  ${Column} {
    margin: 20px 0 0;
    padding-left: 8px;
    padding-right: 8px;
    @media (min-width: 769px) {
      padding-left: 15px;
      padding-right: 15px;
      flex: 0 0 25%;
      max-width: 25%;
      margin-top: 30px;
    }
  }
  ${Card} {
    padding: 0;
  }
  ${CardImage} {
    padding-top: 156px;
    @media (min-width: 1025px) {
      padding-top: 240px;
    }
  }
`;
export const BannerDisplay = styled.div`
  ${BannerWrap} {
    margin: 28px 0 31px;
  }
  @media (min-width: 769px) {
    ${BannerWrap} {
      margin: 30px 0 30px;
    }
    ${BannerTitle} {
      margin-top: 19px;
      margin-bottom: 16px;
      padding-right: 40px;
    }
  }
`;

export const MainWrapper = styled.div`
  ${PreviewImg} {
    & > div {
      width: 100% !important;
      height: 100% !important;
    }
  }
`;

export const RatingWrapMobile = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0px 0px 15px 0px;
  ${StarSVG} {
    width: 15px;
    height: 15px;
    stroke: ${(props) => (props.hasReviews ? colors.STAR_ORANGE : colors.GREY)};
  }
`;

export const RatingWrapDesktop = styled.div`
  margin: -10px -20px 0px 0px;
  display: flex;
  flex-direction: column;
  ${RatingContainer} {
    margin-left: -5px;
  }
  ${StarSVG} {
    width: 15px;
    height: 15px;
    stroke: ${(props) => (props.hasReviews ? colors.STAR_ORANGE : colors.GREY)};
  }
`;

export const RatingText = styled.div`
  color: ${colors.GREY_100};
`;

export const PaidInCollectionBack = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 20px;
  color: ${colors.GREY_SEMIDARK};
  font-family: ${fonts.latoRegular};
  font-size: 16px;
  cursor: pointer;

  .icon {
    width: 20px;
    height: 20px;
    stroke: ${colors.GREY_SEMIDARK};
    fill: ${colors.GREY_SEMIDARK};
    cursor: pointer;
    transform: rotate(180deg) translateX(5px);
  }
`;
